import { render, staticRenderFns } from "./ItemDXCHD.vue?vue&type=template&id=8700be66&scoped=true"
import script from "./ItemDXCHD.vue?vue&type=script&lang=js"
export * from "./ItemDXCHD.vue?vue&type=script&lang=js"
import style0 from "./ItemDXCHD.vue?vue&type=style&index=0&id=8700be66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8700be66",
  null
  
)

export default component.exports